import EditTurnForm from "./editTurn";
import { Modal } from "../../../components/others/Modal/index";

type TProps = {
  toggleModal: boolean;
  urlTittle?: string;
  refreshFunction?: Function;
  patient?: {
    DNI: string;
    id: string;
    company: {
      fantasyName: string;
    };
    name: string;
  };
  onClose?: Function;
  isApplicant?:boolean
};

const EditTurn = ({ toggleModal, urlTittle, patient, refreshFunction, onClose, isApplicant }: TProps) => {
  const styles = "text-2xl text-red-500 font-bold";
  return (
    <>
      <Modal
        show={toggleModal}
        modalTitle={"Editar un turno"}
        titleStyle={styles}
        urlTittle={urlTittle}
        onClose={()=> onClose?.()}
      >
        {/* <div className="bg-red-500 my-8 p-2 rounded-lg text-white  text-center">
          Editar un Turno puede modificar el día y horario acordado inicialmente
        </div> */}

        <EditTurnForm refreshFunction={refreshFunction} isApplicant={isApplicant}/>
      </Modal>
    </>
  );
};

export default EditTurn;
